'use client';

import * as React from 'react';

import { Modal } from '@/components/antd-wrapper/modal/global/modal';
import UpdatePasswordContent from '../update-password';

interface ChangePasswordModalProps {
  open: boolean;
  account: string;
  onClose: () => void;
}

const ChangePasswordModal = ({
  open,
  account,
  onClose,
}: ChangePasswordModalProps) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title=""
      width={464}
      height={656}
      headerHeight={0}
      footer={null}
      className="change-password-modal"
      classNames={{
        content: '!rounded-[20px] !pb-[0]',
      }}
    >
      <div className="flex items-center justify-center h-full">
        <UpdatePasswordContent
          type="password_change"
          backFillAccount={account}
          hasBackButton={false}
          returnUrl={location.href}
        />
      </div>
    </Modal>
  );
};

export default ChangePasswordModal;
